<template>
  <div class="pi-circle-process">
    <div>
      <canvas ref="myCanvas" width="190" height="190"></canvas>
    </div>
    <div class="content">
      <div class="charge-value">{{processPercent}}</div>
      <div class="charge-value-tag">充电进度</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pi-circle-process',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
    }
  },
  watch:{
    value () {
      this.draw();
    }
  },
  computed: {
    processPercent () {
      if (typeof (this.value) === 'number') {
        return (this.value * 10000 / 100).toFixed(0) + '%';//乘以10000除以100解决浮点精度问题
      } else {
        return '-';
      }
    }
  },
  data () {
    return {
      title: '',
      groupTop: '',
      canvasWidth: 190,
      canvasHeight: 190,
    };
  },
  methods: {
    draw () {
      let centerX = this.canvasWidth / 2;
      let centerY = this.canvasHeight / 2;
      let radius = this.canvasHeight / 2;
      let borderWidth = 8;
      let process = this.value > 1 ? 1: this.value;

      let c = this.$refs.myCanvas;
      let ctx = c.getContext('2d');
      ctx.clearRect(0,0,c.width,c.height);//清空画布

      //绘制弓形，通过反余弦的方法获取弧度，然后绘制即可
      let sAngle = 0; //开始角度
      let eAngle = 0; //结束角度
      if (process <= 0.5) {
        let percent = process / 0.5;
        console.log(percent);
        sAngle = Math.PI * 0.5 - Math.acos((radius - radius * percent) / radius);
        eAngle = Math.PI * 0.5 + Math.acos((radius - radius * percent) / radius);
      } else {
        let percent = (process - 0.5)/ 0.5;
        console.log(percent);
        sAngle = Math.PI * 0 - Math.asin((radius * percent) / radius);
        eAngle = Math.PI * 1 + Math.asin((radius * percent) / radius);

      }
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius - borderWidth, sAngle, eAngle);
      ctx.closePath();
      ctx.fillStyle = '#A1EBCC';
      ctx.fill();

      //绘制圆环
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius - borderWidth / 2, 0, Math.PI * 2);
      ctx.lineWidth = borderWidth;
      ctx.strokeStyle = '#EAE8EA';
      ctx.stroke();

    },
  },
  mounted () {
    this.draw();
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.pi-circle-process {
  position: relative;
  .content {
    width: 158px;
    height: 158px;
    position: absolute;
    top: 17px;
    left: 17px;
    background: url("../../assets/img/bg_process.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    .charge-value {
      font-size: 40px;
      line-height: 50px;
    }
    .charge-value-tag {
      font-size: 17px;
      line-height: 26px;
    }
  }
}
</style>
